import axios from "axios";
import { ApiGeeAuthenticationResponse } from "./types";
import { GEARS_TOKEN, GEARS_TOKEN_EXPIRATION_DATE, ID_TOKEN } from "@constants";

const headers = {
  Accept: "application/json",
};

const storeApigeeToken = (data: ApiGeeAuthenticationResponse) => {
  sessionStorage.setItem(GEARS_TOKEN_EXPIRATION_DATE, data.date_created);
  sessionStorage.setItem(GEARS_TOKEN, data.token);
};

// The backend validates the signed-in user before minting this gateway token.
const fetchApigeeToken = async (): Promise<ApiGeeAuthenticationResponse> => {
  const idToken = sessionStorage.getItem(ID_TOKEN);
  if (!idToken) {
    throw new Error("A signed-in user is required to request a gateway token.");
  }

  const { data } = await axios.get<ApiGeeAuthenticationResponse>(
    `${process.env.REACT_APP_API_URL || ""}/api/v1/apigee-token`,
    {
      headers: {
        ...headers,
        "X-gears-token": idToken,
      },
    }
  );
  return data;
};

export const apiGeeAuthentication =
  async (): Promise<ApiGeeAuthenticationResponse | null> => {
    if (isTokenExpiratedOrNull()) {
      const data = await fetchApigeeToken();
      storeApigeeToken(data);
      return data;
    }

    return null;
  };

export function isTokenExpiratedOrNull(): boolean {
  const tokenSessionExpirationDate = sessionStorage.getItem(
    GEARS_TOKEN_EXPIRATION_DATE
  );
  const tokenGearsSession = sessionStorage.getItem(GEARS_TOKEN);

  if (tokenSessionExpirationDate === null || tokenGearsSession === null) {
    return true;
  } else {
    const expireDate = new Date(tokenSessionExpirationDate);
    expireDate.setHours(expireDate.getHours() + 1);

    const actualDate = new Date();
    return actualDate > expireDate;
  }
}
